import React, { useEffect } from "react";
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { setAnalyticsEvent } from "../../core/helpers/analytics";

export default function NeftRtgsDetails(props) {
  const {
    openNeftRtgs,
    toggleNeftRtgs,
    amount,
    neftPaymentSuccess,
    isAdvisory,
    subPartnerRedirectUrl,
    cashfreeOrderId
  } = props;

  const handlePay = () => {
    if (isAdvisory) {
      window.location.href = `${subPartnerRedirectUrl}/orders/${cashfreeOrderId}/payments/status/?status=success`;
    } else {
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("SI" + props?.product + "PaymentInitiated");
      }
      neftPaymentSuccess();
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <Modal
      size="xl"
      isOpen={openNeftRtgs}
      className="neft-modal"
      // contentClassName="h-100"
    >
      <ModalHeader toggle={toggleNeftRtgs} style={{ borderBottom: "6px solid #283A97" }}>
        <p className="justify-content-center text-center text-secondary font-weight-semi-bold font-size-18">
          Instructions for NEFT/RTGS Details
        </p>
      </ModalHeader>
      {/* <div className="border" /> */}
      <ModalBody className="text-center">
        <div className="px-4 py-3 h-100 text-left">
          <p>
            Please add the following account in your bank as beneficiary for
            NEFT/RTGS payments. Once the beneficiary is set-up you can place and
            pay for your orders in the following manner.
          </p>
          <p className="text-left">
            Login into your bank account and initiate your NEFT/RTGS transfers for
            the total amount.
          </p>
          {props?.userInRfq ? <p style={{fontSize : "20px"}} className="text-center text-primary font-weight-semi-bold"> Kindly ensure that you transfer money to the beneficiary details mentioned here.</p> : null}
          {props?.userInRfq ? <Table bordered>
            <tr style={{ "backgroundColor": "#D9D9D9" }}>
              <td style={{ "border": "none", "backgroundColor": "#D9D9D9" }} colSpan={2} className="font-weight-semi-bold text-center"> Beneficiary details to be added for NEFT/RTGS transactions</td>
            </tr>
            <tr className="text-left">
              <td className="font-weight-semi-bold">Beneficiary Account Number</td>
              <td>Current- 57500001086245</td>
            </tr>
            <tr className="text-left">
              <td className="font-weight-semi-bold">Beneficiary Name</td>
              <td>Indian Clearing Corporation Limited</td>
            </tr>
            <tr className="text-left">
              <td className="font-weight-semi-bold">IFSC</td>
              <td>HDFC0000060</td>
            </tr>
            <tr className="text-left">
              <td className="font-weight-semi-bold">Bank Name</td>
              <td>HDFC Bank Ltd</td>
            </tr>
            <tr className="text-left">
              <td className="font-weight-semi-bold">Branch Details</td>
              <td>Fort Branch, Mumbai</td>
            </tr>
          </Table>
          :
          <Table bordered>
          <tr>
            <td>Beneficiary Account Number</td>
            <td>Current- 2223330088393868</td>
          </tr>
          <tr>
            <td>Beneficiary Name</td>
            <td>Alpha Fintech Private Limited</td>
          </tr>
          <tr>
            <td>IFSC</td>
            <td>RATN0VAAPIS</td>
          </tr>
          <tr>
            <td>Branch Details</td>
            <td>Mumbai</td>
          </tr>
          <tr>
            <td>Bank Name</td>
            <td>RBL BANK</td>
          </tr>         
        </Table>}
          <p>
            <span className="text-center" style={{ fontWeight: "900" }}>Please note:</span> The transaction will be processed subject to the realization of payment within 24 hours.</p>
          {/* <p className="text-center pt-2 mb-1">
            For further questions please reach out to
            </p>
            <p className="text-secondary text-center font-weight-semi-bold">
            connect@biddeasy.com
           </p> */}
          <div className="btn-container text-center">
            <Button className="secondary" onClick={handlePay} disabled={props?.loaderForNEFT}>
              {props.paymentTried ? "Close" : "Place Order"}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}